 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>天气</h3>
            <div
              style="
                margin-left: 70px;
                margin-top: -22px;
                width: 1200px;
                display: flex;
              "
            >
              <span style="width: 120px">预警：</span>
              <walkingLantern
                v-if="weatherAlarmData.length > 0"
                :sendVal="weatherAlarmData"
              ></walkingLantern>
            </div>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleReturn"
              >返回决策模型</el-button
            >
          </div>
        </div>
      </div>
      <div class="container1">
        <el-descriptions :column="4" title="实时天气" class="desc-row">
          <el-descriptions-item label="温度">{{
            nowWeatherData.temp + "℃"
          }}</el-descriptions-item>
          <el-descriptions-item label="湿度">{{
            nowWeatherData.humidity + "RH%"
          }}</el-descriptions-item>
          <el-descriptions-item label="风向">{{
            nowWeatherData.windDir
          }}</el-descriptions-item>
          <el-descriptions-item label="风力">{{
            nowWeatherData.windScale + "级"
          }}</el-descriptions-item>
          <el-descriptions-item label="风速">{{
            nowWeatherData.windSpeed + "km/h"
          }}</el-descriptions-item>
          <el-descriptions-item label="降雨量">{{
            nowWeatherData.precip + "mm"
          }}</el-descriptions-item>
          <el-descriptions-item label="大气压强">{{
            nowWeatherData.pressure + "Pa"
          }}</el-descriptions-item>
          <el-descriptions-item label="PM2.5">{{
            nowWeatherData.pm2p5 + "μg/m3"
          }}</el-descriptions-item>
          <el-descriptions-item label="二氧化氮">{{
            nowWeatherData.no2 + "ppm"
          }}</el-descriptions-item>
          <el-descriptions-item label="二氧化硫">{{
            nowWeatherData.so2 + "ppm"
          }}</el-descriptions-item>
          <el-descriptions-item label="一氧化碳">{{
            nowWeatherData.co + "ppm"
          }}</el-descriptions-item>
          <el-descriptions-item label="臭氧">{{
            nowWeatherData.o3 + "ppm"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="container1">
        <el-descriptions title="预报天气" class="desc-title"> </el-descriptions>
        <div class="table_content1">
          <el-table
            :data="preWeatherData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="日期">
              <template slot-scope="scope">
                <p>{{ scope.row.fxDate }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="温度（℃）">
              <template slot-scope="scope">
                <p>{{ scope.row.tempMin + "~" + scope.row.tempMax }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="湿度（RH%）">
              <template slot-scope="scope">
                <p>{{ scope.row.humidity }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="大气压强（Pa）">
              <template slot-scope="scope">
                <p>{{ scope.row.pressure }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计降水量（mm）">
              <template slot-scope="scope">
                <p>{{ scope.row.precip }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container1" style="min-height: 500px; margin-bottom: 20px">
        <el-descriptions title="历史天气" class="desc-title"> </el-descriptions>
        <div>
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
            style="margin-left: -5px"
          >
            <el-form-item label="天气参数：">
              <el-select
                v-model="searchForm.attributeId"
                placeholder="请选择天气参数"
                @change="handleSearch"
              >
                <el-option value="0" label="温度"></el-option>
                <el-option value="1" label="湿度"></el-option>
                <el-option value="2" label="降雨量"></el-option>
                <el-option value="3" label="大气压强"></el-option>
                <el-option value="4" label="PM2.5"></el-option>
                <el-option value="5" label="二氧化碳"></el-option>
                <el-option value="6" label="二氧化硫"></el-option>
                <el-option value="7" label="一氧化碳"></el-option>
                <el-option value="8" label="臭氧"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="历史日期">
              <el-date-picker
                v-model="date"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div
            id="myChart"
            style="width: 100%; height: 400px; display: inline-block"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import echarts from "echarts";
import walkingLantern from "@/components/walkingLantern.vue";
export default {
  components: {
    walkingLantern,
  },
  data() {
    return {
      searchForm: {
        // 查询条件字段
        id: "",
        attributeId: "0",
        startDate: "",
        endDate: "",
      },
      date: [],
      nowWeatherData: {
        // 今天天气
        temp: "",
        humidity: "",
        windDir: "",
        windScale: "",
        windSpeed: "",
        precip: "",
        pressure: "",
        pm2p5: "",
        no2: "",
        so2: "",
        co: "",
        o3: "",
      },
      preWeatherData: [], // 3天天气
      weatherAlarmData: [], // 天气告警
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.searchForm.id = this.$route.query.decisionId;

    // 默认今天
    let day = this.getDate();
    this.searchForm.startDate = day;
    this.searchForm.endDate = day;
    this.date = [day, day];

    // 获取天气告警
    this.getWeatherAlarm();

    // 获取今天天气
    this.getNowWeather();

    // 获取天气3天预报
    this.getPreWeather();

    // 获取历史天气
    this.handleSearch();
  },
  methods: {
    // 获取今天，dates为数字类型，0代表今日,-1代表昨日，1代表明日，返回yyyy-mm-dd格式字符串，dates不传默认代表今日
    getDate(dates) {
      var dd = new Date();
      var n = dates || 0;
      dd.setDate(dd.getDate() + n);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      var day = y + "-" + m + "-" + d;
      return day;
    },
    // 获取天气告警
    getWeatherAlarm() {
      this.$api.growthModel
        .getWeatherAlarm({ id: this.searchForm.id })
        .then((res) => {
          if (res.code == 200) {
            this.weatherAlarmData = res.data;
          }
        });
    },
    // 获取今天天气
    getNowWeather() {
      this.$api.growthModel
        .getNowWeather({ id: this.searchForm.id })
        .then((res) => {
          if (res.code == 200) {
            this.nowWeatherData = res.data;
          }
        });
    },
    // 获取天气3天预报
    getPreWeather() {
      this.loading = true;
      this.$api.growthModel
        .getPreWeather({ id: this.searchForm.id })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.preWeatherData = res.data;
          }
        });
    },
    // 查询历史天气
    handleSearch() {
      if (!this.searchForm.attributeId || this.searchForm.attributeId == "") {
        this.$message({
          message: "请选择天气参数",
          type: "error",
        });
        return;
      }

      if (!this.date || this.date.length != 2) {
        this.$message({
          message: "请选择历史日期",
          type: "error",
        });
        return;
      }

      this.searchForm.startDate = this.date[0];
      this.searchForm.endDate = this.date[1];
      this.$api.growthModel.getHisWeather(this.searchForm).then((res) => {
        if (res.code == 200) {
          let xDataList = res.data.timeList;
          let yDataList = res.data.dataList;

          setTimeout(() => {
            // 初始化
            this.initChart(xDataList, yDataList);
          }, 500);
        }
      });
    },
    // 初始化图表
    initChart(xDataList, yDataList) {
      var myChart = document.getElementById("myChart");
      var chartObj = echarts.init(myChart);
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["#0356fe"],
        legend: {
          textStyle: {
            //图例文字的样式
            color: "#6a7985",
            fontSize: 14,
          },
        },
        xAxis: {
          axisLabel: {
            showMaxLabel: true,
          },
          type: "category",
          data: xDataList,
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#ccc"],
              width: 1,
              type: "solid",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#333",
              width: 1, //这里是为了突出显示加上的
            },
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#ccc"],
              width: 1,
              type: "solid",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#333",
              width: 1, //这里是为了突出显示加上的
            },
          },
          boundaryGap: false,
        },
        series: {
          name: this.getWeatherParamName(this.searchForm.attributeId),
          type: "line",
          symbol: "none",
          smooth: true,
          symbolSize: 0,
          lineStyle: {
            color: "#0356fe",
          },
          data: yDataList,
        },
        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: "8%",
          right: "5%",
          bottom: "10%",
        },
      };
      chartObj.setOption(option);
    },
    // 获取天气参数名称
    getWeatherParamName(param) {
      let name = "";
      switch (param) {
        case "0":
          name = "温度（℃）";
          break;
        case "1":
          name = "湿度（RH%）";
          break;
        case "2":
          name = "降雨量（mm）";
          break;
        case "3":
          name = "大气压强（Pa）";
          break;
        case "4":
          name = "PM2.5（μg/m3）";
          break;
        case "5":
          name = "二氧化碳（ppm）";
          break;
        case "6":
          name = "二氧化硫（ppm）";
          break;
        case "7":
          name = "一氧化碳（ppm）";
          break;
        case "8":
          name = "臭氧（ppm）";
          break;
      }

      return name;
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
  margin-top: 10px;
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.desc-row {
  padding: 15px;
}

.desc-title {
  height: 50px;
  padding-left: 15px;
  padding-top: 15px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>